import { createReducer } from "../../../common/reduxUtil";
import { DMAT_SET_CHECKOUT } from "./types";

const initialState = {
  checkout: false,
};

export default createReducer(initialState, {
  [DMAT_SET_CHECKOUT]: (state, checkout) => ({ ...state, checkout }),
});
